// @flow
import { loadTicket } from '../../../duck/actions';

export { loadTicket } from '../../../duck/actions';

export default { loadTicket };
